import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';


import ReactTable from "react-table";
import "react-table/react-table.css";

import Spinner from 'react-spinkit';

import moment from 'moment';

import * as actions from '../../actions/proveedores';

import IconSave from 'react-icons/lib/md/save';
import swal from 'sweetalert2'

import {api, request, API_URL} from '../../actions/_request';
import ModalTablas from '../../components/catalogos/modal_tablas';
import Almacen from "../almacenes/Modal";



const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);

class KardexProveedor extends React.Component{
	constructor(props) {

        super(props);

        this.state = {
           	fecha_inicio : '2000-01-01',
           	fecha_fin 	 : moment().add(1, 'days').format('Y-MM-DD'),
            almacen_id:0,
            almacen_codigo:'',
            almacen_descripcion:"",
            /*modal para agrgar nuevos registros*/
            modal_registro:0,
            tittle_registro:'',
        };
        
        this.buscar = this.buscar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this); 


         this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
        this.toggle_modal_registro= this.toggle_modal_registro.bind(this); 
    }
     modal_open(){
       document.getElementById('body').className = "modal-open modal-open";
    }
    toggle_modal_registro(objeto,opcion=0,titulo=''){
      // console.log('opcion---->',opcion);
      if(opcion==0||opcion=='[object Event]'){
         // console.log('se agrega un modal-open')
        // setTimeout(this.modal_open, 1000);
         
         //if(this.state.tabla_modal==14)
        //  document.getElementById('body').className = "modal-open modal-open";

        this.setState({
            modal : false,
            modal_productos:false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }else{
        console.log('nada')
        this.setState({
            modal : false,
            modal_productos:false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }
    }

    handleClose (event) {
        console.log('evento--->',event)
         
        let {compra} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        
         switch (name) {
            case "almacen_codigo":                  
                  campo = "almacen_id";
                  tabla="/busqueda_almacen";
                  break;
     
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        /*aqui va el request para buscar el saldo*/
                        let  retorno=response.data
                   

                         self.retorno(retorno,campo,vaciar,value);
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }
                            
                   
                }

            });
        }else{
            self.retorno([],campo,1,value); 
        }
            

   }

    ChangeCode(event) {
     
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    retorno(objeto,campo,vacio=0,valor=""){
        let codigo="";
        let descripcion="";
        let campo_codigo="";
        let campo_descripcion="";
        let almacen_id=0;
     
        console.log('renglon---->',objeto);
        let {compra} = this.state;
        let self =this;
        switch (campo) {

            case "almacen_id":
                  codigo=objeto.codigo;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="almacen_codigo";
                  campo_descripcion="almacen_descripcion"; 
                  almacen_id = objeto.value?objeto.value:objeto.id;
                  break;
            
        }  
       if(vacio==1){
        console.log('vaciar')
        codigo=valor;
        descripcion="";
        almacen_id =0;
       }

       

       
    
         self.setState({
            almacen_id : almacen_id,           
            [campo_codigo]:codigo,
            [campo_descripcion]:descripcion,
            modal:false,         
        })

    
       


    }
    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }  

    handleInputChange(event) {
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    buscar(evt){
    	evt.preventDefault();

    	let {fecha_inicio , fecha_fin,almacen_id } = this.state;
    	let { articulo_id,consulta_id } = this.props;

    	console.log('fecha_fin ===>', fecha_fin)
    	console.log('fecha_inicio ===>', fecha_inicio)
    	// console.log('proveedor ===>', proveedor)
     switch (parseInt(consulta_id) ) {
          case 2:
             window.open(`${API_URL}/cardex/${articulo_id}/${fecha_inicio}/${fecha_fin}/${almacen_id}`);
            break;
            case 3:
               window.open(`${API_URL}/articulo_vendido_comprado/${articulo_id}/${fecha_inicio}/${fecha_fin}/2`);
              break;
            case 4:
               window.open(`${API_URL}/articulo_vendido_comprado/${articulo_id}/${fecha_inicio}/${fecha_fin}/1`);
              break;
          
          default:
           
            break;
        }
     
    }

    render(){
    	let {fecha_inicio , fecha_fin } = this.state;
      console.log('props--->',this.props);
    	return(
    		<Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>{this.props.articulo.label}</ModalHeader>
                <ModalBody>
                <div className="row">
                                <div className="col-md-4"> 
                                        <div className="form-group">
                                            <label className="d-block">Almacen:</label>
                                            <Input
                                            placeholder=""
                                            name="almacen_codigo"
                                            value={this.state.almacen_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                             className="input_button"
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(25,"Almacenes","almacen_id") } }>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="">{this.state.almacen_descripcion}</label>
                                </div>
                                </div>
                	<div className="row">
                		<div className="col-4">
                			<div className="form-group">
                   				<label>inicio</label>
                   				<Input
                   					placeholder=""
                   					type="date"
                   					name="fecha_inicio"
                   					value={fecha_inicio}
                   					onChange={this.handleInputChange}
                   				/>
                   			</div>
                		</div>
                		<div className="col-4">
                			<div className="form-group">
                   				<label>Fin</label>
                   				<Input
                   					placeholder=""
                   					type="date"
                   					name="fecha_fin"
                   					value={fecha_fin}
                   					onChange={this.handleInputChange}
                   				/>
                   			</div>
                		</div>
                	</div>
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.inventario.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.buscar} >
                                <IconSave />&nbsp;Buscar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
                { this.state.modal&&
                 <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    agregar={this.toggle_modal_registro}
                />
                }

                 {
                   this.state.modal_registro==25&& 
                   <Almacen 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
            </Modal>
    	);
    }
}

function mapStateToProps(state, ownProps) {
    return {
         inventario : state.inventario,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(KardexProveedor)


// WEBPACK FOOTER //
// ./src/views/inventario/ModalKardexArticulo.js